import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
import * as format from "../../common/FormatFunctions";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import { logout } from "../../common/helpers/auth";

export class ManageSets extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      instructorList: "",
      setList: [],
      setSelected: false,
      selectedSet: "",
      selectedSetId: "",
      selectedSetServiceId: "",
      selectedSetLastUpdatedDateTime: "",
      selectedSetTitle: "",
      selectedSetLevel: "",
      selectedSetMaxNumberOfParticipants: "",
      selectedSetNumberOfParticipants: "",
      selectedSetStatus: "",
      selectedSetNextClass: "",
      selectedSetRoom: "",
      selectedSetRoomName: "",
      selectedSetCost: "",
      selectedSetInstructors: "",
      selectedSetInstructorNames: "",
      selectedSetClients: "",
      selectedSetClientNames: "",
      selectedSetBookList: [],
      selectedSetCompleteBookedListUserDetails: [],
      selectedSetStartDateDisplayString: "",
      selectedSetEndDateDisplayString: "",
      selectedSetMondayTime: [],
      selectedSetMondayStart: "",
      selectedSetMondayEnd: "",
      selectedSetTuesdayTime: [],
      selectedSetTuesdayStart: "",
      selectedSetTuesdayEnd: "",
      selectedSetWednesdayTime: [],
      selectedSetWednesdayStart: "",
      selectedSetWednesdayEnd: "",
      selectedSetThursdayTime: [],
      selectedSetFridayTime: [],
      selectedSetFridayStart: "",
      selectedSetFridayEnd: "",
      selectedSetSaturdayTime: [],
      selectedSetSaturdayStart: "",
      selectedSetSaturdayEnd: "",
      selectedSetSundayTime: [],
      selectedSetSundayStart: "",
      selectedSetSundayEnd: "",
      setEdited: false,
      editSet: "",
      editSetTitle: "",
      editSetLevel: "",
      editSetMaxNumberOfPartcipants: "",
      editSetStatus: "",
      editSetNextClass: "",
      editSetRoom: "",
      editSetRoomName: "",
      editSetCost: "",
      editSetInstructors: "",
      editSetInstructorNames: "",
      pickListAvailable: [],
      pickListSelected: [],
      clientList: [],
      clientOptions: [],
      selectedClient: "",
      clientUserId: "",
      deleteDialog: false,
      roomList: [],
      roomOptions: [],
      selectedPaidOnClick: "",
      selectedPaymentMethodOnClick: "",
    };

    this.updateClientsBooksForSet = this.updateClientsBooksForSet.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  componentDidMount = async () => {
    if (localStorage.getItem("roleType") === "30") {
      logout();
      localStorage.clear();
      window.location = "#/";
      window.location.reload();
    }
    this.getRooms();
    this.getClients();
    this.getInstructors();
    this.getSets();
  };

  getRooms = async () => {
    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");
    roomRequest.userId = localStorage.getItem("userId");

    await api("roomApiV1RoomGetByCodeTag", roomRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.roomList)) {
          res.data.roomList.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let roomResponse =
          Belfastpilatesappspotcom.RoomResponse.constructFromObject(res.data);
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState({ roomList: roomResponse.roomList }, () => {
            this.roomsToOptions();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Rooms could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("roomApiV1RoomGetByCodeTag has failed");
      }
    });
  };

  roomsToOptions = () => {
    let roomArray = [];

    if (Array.isArray(this.state.roomList)) {
      this.state.roomList.forEach((e) => {
        roomArray.push({ label: e.name, value: e.id });
      });
    }

    this.setState({ roomOptions: roomArray });
  };

  deleteClient = async (clientId) => {
    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.id = this.state.selectedSetId;
    setRequest.userId = clientId;

    await api("setApiV1SetRemoveUser", setRequest).then((res) => {
      if (res.data) {
        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "User removed from set",
            life: 3000,
          });
          this.setState({ setEdited: false }, () => {
            this.getSets(true, true);
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "User could not be removed from set, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1UserRemoveFromSet has failed");
      }
    });
  };

  emailUserForPayment = async (clientId) => {
    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = clientId;

    await api("setApiV1SetsEmailUnpaidClient", setRequest).then((res) => {
      if (res.data) {
        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "User emailed",
            life: 3000,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "User could not be emailed",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetsEmailUnpaidClient has failed");
      }
    });
  };

  updateClients = async () => {
    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.employeeUserId = localStorage.getItem("userId");
    bookRequest.setId = this.state.selectedSetId;
    bookRequest.lastUpdatedDateTime = this.state.selectedSetLastUpdatedDateTime;
    bookRequest.userId = this.state.selectedClient;
    bookRequest.indentifier = "CREATE";
    bookRequest.paid = this.state.selectedPaid;
    bookRequest.paymentMethod = this.state.selectedPaymentMethod;

    await api("bookApiV1BookCreateBySet", bookRequest).then((res) => {
      if (res.data) {
        let bookResponse =
          Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          this.setState(
            {
              setEdited: false,
              selectedClient: "",
              selectedPaid: "",
              selectedPaymentMethod: "",
            },
            () => {
              this.getSets(true, true);
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Clients could not be updated, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("bookApiV1BookCreateBySet has failed");
      }
    });
  };

  updateClientsBooksForSet = async () => {
    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.setId = this.state.selectedSetId;
    bookRequest.userId = this.state.clientUserId;
    bookRequest.identifier = "BOOK";
    bookRequest.paid = this.state.selectedPaidOnClick;
    bookRequest.paymentMethod = this.state.selectedPaymentMethodOnClick;

    await api("bookApiV1BookUpdateBySetForClientUser", bookRequest).then(
      (res) => {
        if (res.data) {
          let bookResponse =
            Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
          console.log(bookResponse);

          if (bookResponse.errorCode === 0) {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Clients Payment Method successfully updated",
              life: 3000,
            });

            let userDetails =
              this.state.selectedSetCompleteBookedListUserDetails;

            if (Array.isArray(userDetails)) {
              userDetails.forEach((e) => {
                if (this.state.clientUserId === e.userId) {
                  e.paymentMethod = this.state.selectedPaymentMethodOnClick;
                  e.paid = this.state.selectedPaidOnClick;
                }
              });
            }

            this.setState({
              selectedSetCompleteBookedListUserDetails: userDetails,
              selectedClient: "",
              clientUserId: "",
              selectedPaidOnClick: "",
              selectedPaymentMethodOnClick: "",
              displayDialog: false,
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail:
                "Clients payment method could not be updated, please try again",
              life: 3000,
            });

            this.setState({
              selectedClient: "",
              clientUserId: "",
              selectedPaidOnClick: "",
              selectedPaymentMethodOnClick: "",
              displayDialog: false,
            });
          }
        } else {
          console.log("bookApiV1BookUpdateBySetForClientUser has failed");
        }
      }
    );
  };

  getClients = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.roleType = 30;

    await api("userApiV1UserListByRoleType", userRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.users)) {
          res.data.users.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            clientList: userResponse.users,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Clients could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListByRoleType has failed");
      }
    });
  };

  clientsToOptions = () => {
    let that = this;
    let clientArray = [];

    if (Array.isArray(this.state.clientList)) {
      this.state.clientList.forEach((e) => {
        if (Array.isArray(e.level)) {
          e.level.forEach((f) => {
            if (f === that.state.selectedSetLevel) {
              clientArray.push({
                label: e.firstName + " " + e.surname,
                value: e.id,
              });
            }
          });
        }
      });
    }

    this.setState({ clientOptions: clientArray });
  };

  getInstructors = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then((res) => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse =
          Belfastpilatesappspotcom.UserResponse.constructFromObject(res.data);
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            instructorList: userResponse.users,
            pickListAvailable: userResponse.users,
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Instructors could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });
  };

  getSets = async (keepView, keepEditing) => {
    this.setState({ loaded: false });

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = localStorage.getItem("userId");
    setRequest.bookIdentifier = "CREATE";

    await api("setApiV1SetGetByCodeTag", setRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.setList)) {
          res.data.setList.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (e.startDate) {
              e.startDate = e.startDate.toJSON();
            }
            if (e.endDate) {
              e.endDate = e.endDate.toJSON();
            }
          });
        }

        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.setState(
            {
              setList: setResponse.setList,
            },
            async () => {
              await this.getUsersInMultipleSets();
              console.log(this.state.multipleSetUsers);
              if (Array.isArray(this.state.setList)) {
                this.state.setList.forEach((e) => {
                  if (e.id === localStorage.getItem("selectedSetId")) {
                    this.setState({ selectedSet: e });
                    localStorage.removeItem("selectedSetId");
                  }
                });

                if (keepView) {
                  this.reSelectSet(this.state.selectedSetId, keepEditing);
                } else {
                  this.setState({ setSelected: false, setEdited: false });
                }
              }
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Sets could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetGetByCodeTag has failed");
      }
    });

    this.setState({ loaded: true });
  };

  getUsersInMultipleSets = async () => {
    this.setState({ loaded: false });

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = localStorage.getItem("userId");
    setRequest.bookIdentifier = "CREATE";

    await api("setApiV1SetGetUsersInMultiple", setRequest).then((res) => {
      if (res.data) {
        if (Array.isArray(res.data.setList)) {
          res.data.setList.forEach((e) => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (e.startDate) {
              e.startDate = e.startDate.toJSON();
            }
            if (e.endDate) {
              e.endDate = e.endDate.toJSON();
            }
          });
        }

        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.setState({ multipleSetUsers: setResponse.multipleSetUsers });
        } else {
          this.setState({ multipleSetUsers: [] });
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Users in Multiple sets could not be retrieved",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetGetUsersInMultiple has failed");
      }
    });

    this.setState({ loaded: true });
  };

  reSelectSet = async (selectedSetId, keepEditing) => {
    console.log(this.state.setList);
    this.state.setList.forEach((e) => {
      if (selectedSetId === e.id) {
        let instructorNamesArray = [];
        let i2 = 0;
        let clientNamesArray = [];
        let i3 = 0;
        let roomName = "";

        if (Array.isArray(this.state.roomList)) {
          this.state.roomList.forEach((r) => {
            if (r.id === e.roomId) {
              roomName = r.name;
            }
          });
        }

        if (Array.isArray(e.instructorDetails)) {
          e.instructorDetails.forEach((f) => {
            instructorNamesArray[i2] = (
              <li key={i2}>{f.firstName + " " + f.surname}</li>
            );
            i2++;
          });
        }

        if (Array.isArray(e.bookedUserDetails)) {
          e.bookedUserDetails.forEach((f) => {
            clientNamesArray[i3] = (
              <li key={i3}>{f.firstName + " " + f.surname}</li>
            );
            i3++;
          });
        }

        if (format.isNotNull(e.completeBookedListUserDetails)) {
          e.completeBookedListUserDetails.forEach((f) => {
            f.multipleSets = "No";
            if (format.isNotNull(this.state.multipleSetUsers)) {
              this.state.multipleSetUsers.forEach((g) => {
                if (f.userId === g) {
                  f.multipleSets = "Yes";
                }
              });
            }
          });
        }

        this.setState(
          {
            setEdited: false,
            setSelected: true,
            selectedSet: e,
            selectedSetId: e.id,
            selectedSetServiceId: e.serviceId,
            selectedSetLastUpdatedDateTime: e.lastUpdatedDateTime,
            selectedSetTitle: e.title,
            selectedSetLevel: e.level,
            selectedSetMaxNumberOfParticipants: e.maxSpace,
            selectedSetNumberOfParticipants: e.currentNumberOfUsers,
            selectedSetStatus: e.status,
            selectedSetRoom: e.roomId,
            selectedSetRoomName: roomName,
            selectedSetCost: e.cost,
            selectedSetInstructors: e.instructorDetails,
            selectedSetInstructorNames: instructorNamesArray,
            selectedSetClients: e.bookedUserDetails,
            selectedSetClientNames: clientNamesArray,
            selectedSetBookList: e.bookList,
            selectedSetCompleteBookedListUserDetails:
              e.completeBookedListUserDetails,
            pickListSelected: e.instructorDetails,
            selectedSetStartDateDisplayString: e.startDateDisplayString,
            selectedSetEndDateDisplayString: e.endDateDisplayString,
            selectedSetMondayTime: e.mondayTime,
            selectedSetTuesdayTime: e.tuesdayTime,
            selectedSetWednesdayTime: e.wednesdayTime,
            selectedSetThursdayTime: e.thursdayTime,
            selectedSetFridayTime: e.fridayTime,
            selectedSetSaturdayTime: e.saturdayTime,
            selectedSetSundayTime: e.sundayTime,
          },
          () => {
            console.log(this.state.selectedSet);
            this.clientsToOptions();
            this.getNextClass(this.state.selectedSetId);

            window.scrollTo({ top: 0, behavior: "smooth" });

            if (this.state.pickListSelected) {
              this.removePickListDuplicates();
            }

            if (keepEditing) {
              this.setState(
                {
                  setSelected: false,
                  setEdited: true,
                  editSet: this.state.selectedSet,
                  editSetTitle: this.state.selectedSetTitle,
                  editSetLevel: this.state.selectedSetLevel,
                  editSetMaxNumberOfPartcipants:
                    this.state.selectedSetMaxNumberOfParticipants,
                  editSetStatus: this.state.selectedSetStatus,
                  editSetRoom: this.state.selectedSetRoom,
                  editSetNextClass: this.state.selectedSetNextClass,
                  editSetRoomName: this.state.selectedSetRoomName,
                  editSetCost: this.state.selectedSetCost / 100,
                  editSetInstructors: this.state.selectedSetInstructors,
                  editSetInstructorNames: this.state.selectedSetInstructorNames,
                },
                () => {
                  if (Array.isArray(this.state.selectedSetMondayTime)) {
                    this.setState({
                      selectedSetMondayStart:
                        this.state.selectedSetMondayTime[0],
                      selectedSetMondayEnd: this.state.selectedSetMondayTime[1],
                    });
                  }
                  if (Array.isArray(this.state.selectedSetTuesdayTime)) {
                    this.setState({
                      selectedSetTuesdayStart:
                        this.state.selectedSetTuesdayTime[0],
                      selectedSetTuesdayEnd:
                        this.state.selectedSetTuesdayTime[1],
                    });
                  }
                  if (Array.isArray(this.state.selectedSetWednesdayTime)) {
                    this.setState({
                      selectedSetWednesdayStart:
                        this.state.selectedSetWednesdayTime[0],
                      selectedSetWednesdayEnd:
                        this.state.selectedSetWednesdayTime[1],
                    });
                  }
                  if (Array.isArray(this.state.selectedSetThursdayTime)) {
                    this.setState({
                      selectedSetThursdayStart:
                        this.state.selectedSetThursdayTime[0],
                      selectedSetThursdayEnd:
                        this.state.selectedSetThursdayTime[1],
                    });
                  }
                  if (Array.isArray(this.state.selectedSetFridayTime)) {
                    this.setState({
                      selectedSetFridayStart:
                        this.state.selectedSetFridayTime[0],
                      selectedSetFridayEnd: this.state.selectedSetFridayTime[1],
                    });
                  }
                  if (Array.isArray(this.state.selectedSetSaturdayTime)) {
                    this.setState({
                      selectedSetSaturdayStart:
                        this.state.selectedSetSaturdayTime[0],
                      selectedSetSaturdayEnd:
                        this.state.selectedSetSaturdayTime[1],
                    });
                  }
                  if (Array.isArray(this.state.selectedSetSundayTime)) {
                    this.setState({
                      selectedSetSundayStart:
                        this.state.selectedSetSundayTime[0],
                      selectedSetSundayEnd: this.state.selectedSetSundayTime[1],
                    });
                  }
                }
              );
            }
          }
        );
      }
    });
  };

  updateSet = async (ids) => {
    let idArray = [];

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = localStorage.getItem("userId");
    setRequest.id = this.state.selectedSetId;
    setRequest.lastUpdatedDateTime = this.state.selectedSetLastUpdatedDateTime;
    setRequest.title = this.state.editSetTitle;
    setRequest.level = this.state.editSetLevel;
    setRequest.maxSpace = this.state.editSetMaxNumberOfPartcipants;
    setRequest.status = this.state.editSetStatus;
    setRequest.roomId = this.state.editSetRoom;
    setRequest.cost = this.state.editSetCost * 100;
    if (ids) {
      setRequest.instructorIds = ids;
    }
    if (Array.isArray(this.state.pickListSelected)) {
      this.state.pickListSelected.forEach((e) => {
        idArray.push(e.id);
      });
      setRequest.instructorIds = idArray;
    }
    if (Array.isArray(this.state.selectedSetMondayTime)) {
      setRequest.mondayTime = [
        this.state.selectedSetMondayStart,
        this.state.selectedSetMondayEnd,
      ];
    }
    if (Array.isArray(this.state.selectedSetTuesdayTime)) {
      setRequest.tuesdayTime = [
        this.state.selectedSetTuesdayStart,
        this.state.selectedSetTuesdayEnd,
      ];
    }
    if (Array.isArray(this.state.selectedSetWednesdayTime)) {
      setRequest.wednesdayTime = [
        this.state.selectedSetWednesdayStart,
        this.state.selectedSetWednesdayEnd,
      ];
    }
    if (Array.isArray(this.state.selectedSetThursdayTime)) {
      setRequest.thursdayTime = [
        this.state.selectedSetThursdayStart,
        this.state.selectedSetThursdayEnd,
      ];
    }
    if (Array.isArray(this.state.selectedSetFridayTime)) {
      setRequest.fridayTime = [
        this.state.selectedSetFridayStart,
        this.state.selectedSetFridayEnd,
      ];
    }
    if (Array.isArray(this.state.selectedSetSaturdayTime)) {
      setRequest.saturdayTime = [
        this.state.selectedSetSaturdayStart,
        this.state.selectedSetSaturdayEnd,
      ];
    }
    if (Array.isArray(this.state.selectedSetSundayTime)) {
      setRequest.sundayTime = [
        this.state.selectedSetSundayStart,
        this.state.selectedSetSundayEnd,
      ];
    }

    await api("setApiV1SetUpdate", setRequest).then((res) => {
      if (res.data) {
        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.setState({ setEdited: false }, () => {
            this.getSets(true, false);
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Set could not be updated, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetUpdate has failed");
      }
    });
  };

  deleteSet = async () => {
    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = localStorage.getItem("userId");
    setRequest.id = this.state.selectedSetId;
    setRequest.lastUpdatedDateTime = this.state.selectedSetLastUpdatedDateTime;

    await api("setApiV1SetDelete", setRequest).then((res) => {
      if (res.data) {
        let setResponse =
          Belfastpilatesappspotcom.SetResponse.constructFromObject(res.data);
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.growl.show({
            severity: "success",
            summary: "Success",
            detail: "Set successfully deleted",
            life: 3000,
          });
          this.getSets(false, false);
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Set could not be deleted, please try again",
            life: 3000,
          });
        }
      } else {
        console.log("setApiV1SetDelete has failed");
      }
    });
  };

  setsToCard = () => {
    let setArray = [];
    let i = 0;
    let instructorNamesArray = [];
    let i2 = 0;
    let clientNamesArray = [];
    let i3 = 0;

    if (Array.isArray(this.state.setList)) {
      this.state.setList.forEach((e) => {
        let roomName = "";
        if (Array.isArray(this.state.roomList)) {
          this.state.roomList.forEach((r) => {
            if (r.id === e.roomId) {
              roomName = r.name;
            }
          });
        }

        setArray[i] = (
          <div
            key={i}
            id={i}
            className="card"
            onMouseOver={(f) => {
              f.currentTarget.style.boxShadow = "5px 5px 10px grey";
            }}
            onMouseOut={(f) => {
              f.currentTarget.style.boxShadow = "";
            }}
            onClick={(g) => {
              let element = document.getElementById(
                localStorage.getItem("manageSetsLastSelectedCardId")
              );
              if (element) {
                element.style.backgroundColor = "white";
              }
              g.currentTarget.style.backgroundColor = "#F44336";
              localStorage.setItem(
                "manageSetsLastSelectedCardId",
                g.currentTarget.id
              );

              if (Array.isArray(e.instructorDetails)) {
                e.instructorDetails.forEach((f) => {
                  instructorNamesArray[i2] = (
                    <li key={i2}>{f.firstName + " " + f.surname}</li>
                  );
                  i2++;
                });
              }

              if (Array.isArray(e.bookedUserDetails)) {
                e.bookedUserDetails.forEach((f) => {
                  clientNamesArray[i3] = (
                    <li key={i3}>{f.firstName + " " + f.surname}</li>
                  );
                  i3++;
                });
              }

              if (Array.isArray(e.data.completeBookedListUserDetails)) {
                e.data.completeBookedListUserDetails.forEach((f) => {
                  f.multipleSets = "No";
                  if (format.isNotNull(this.state.multipleSetUsers)) {
                    this.state.multipleSetUsers.forEach((g) => {
                      if (f.userId === g) {
                        f.multipleSets = "Yes";
                      }
                    });
                  }
                });
              }

              this.setState(
                {
                  setEdited: false,
                  setSelected: true,
                  selectedSet: e,
                  selectedSetId: e.id,
                  selectedSetServiceId: e.serviceId,
                  selectedSetLastUpdatedDateTime: e.lastUpdatedDateTime,
                  selectedSetTitle: e.title,
                  selectedSetLevel: e.level,
                  selectedSetMaxNumberOfParticipants: e.maxSpace,
                  selectedSetNumberOfParticipants: e.currentNumberOfUsers,
                  selectedSetStatus: e.status,
                  selectedSetRoom: e.roomId,
                  selectedSetRoomName: roomName,
                  selectedSetCost: e.cost,
                  selectedSetInstructors: e.instructorDetails,
                  selectedSetInstructorNames: instructorNamesArray,
                  selectedSetClients: e.bookedUserDetails,
                  selectedSetClientNames: clientNamesArray,
                  selectedSetBookList: e.bookList,
                  selectedSetCompleteBookedListUserDetails:
                    e.completeBookedListUserDetails,
                  pickListSelected: e.instructorDetails,
                },
                () => {
                  console.log(this.state.selectedSet);
                  this.clientsToOptions();
                  this.getNextClass(e.id);

                  window.scrollTo({ top: 0, behavior: "smooth" });

                  if (this.state.pickListSelected) {
                    this.removePickListDuplicates();
                  }
                }
              );
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <div className="ui-g" style={{ textAlign: "center" }}>
              <div className="ui-g-12 ui-md-3" style={{ textAlign: "left" }}>
                <br />
                <h1>{e.title || "No Title Set"}</h1>
              </div>
              <div className="ui-g-12 ui-md-3">
                <br />
                <h1>{e.status || "No Status Set"}</h1>
              </div>
              <div className="ui-g-12 ui-md-2">
                <br />
                <h1>{"£" + e.costToDisplay}</h1>
              </div>
              <div className="ui-g-12 ui-md-2">
                <h1>{e.startDateDisplayString || "No Start Date Set"}</h1>
                <h2>to</h2>
                <h1>{e.endDateDisplayString || "No End Date Set"}</h1>
              </div>
              <div className="ui-g-12 ui-md-2">
                <h1>
                  {"No. Booked: " + (e.currentNumberOfUsers || "No Bookings")}
                </h1>
                <h2>&nbsp;</h2>
                <h1>{"Max Space: " + (e.maxSpace || "No Max Space Set")}</h1>
              </div>
            </div>
          </div>
        );
        i++;
      });
    }

    return setArray;
  };

  removePickListDuplicates = () => {
    let i = 0;

    if (
      Array.isArray(this.state.pickListAvailable) &&
      Array.isArray(this.state.pickListSelected)
    )
      this.state.pickListAvailable.forEach((e) => {
        this.state.pickListSelected.forEach((f) => {
          if (e.id === f.id) {
            let pickListAvailable = this.state.pickListAvailable;
            pickListAvailable.splice(i, 1);
            this.setState({ pickListAvailable: pickListAvailable });
            i--;
          }
        });
        i++;
      });
  };

  getNextClass = async (setId) => {
    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.userId = localStorage.getItem("userId");
    bookRequest.setId = setId;

    await api("bookApiV1BookGetNextBookingForSets", bookRequest).then((res) => {
      if (res.data) {
        let bookResponse =
          Belfastpilatesappspotcom.BookResponse.constructFromObject(res.data);
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          if (bookResponse.bookList[0]) {
            this.setState({
              selectedSetNextClass: bookResponse.bookList[0].dateToDisplay,
            });
          }
          if (bookResponse.bookList[0].buildingBean) {
            this.setState({
              selectedSetRoomName: bookResponse.bookList[0].buildingBean.name,
            });
          }
        } else if (bookResponse.errorCode === 20880) {
          this.setState({
            selectedSetNextClass: "No next class",
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Next class could not be retrieved, please refresh and try again",
            life: 3000,
          });
        }
      } else {
        console.log("bookApiV1BookGetNextBookingForSets has failed");
      }
    });
  };

  closeDialog = () => {
    this.setState({
      displayDialog: false,
    });
  };

  render() {
    let dialogFooter = (
      <div className="ui-g">
        <div className="ui-g-12">
          <pr.Button
            label="Cancel"
            icon="pi pi-times"
            onClick={this.closeDialog}
          />
          <pr.Button
            label="Save"
            icon="pi pi-check"
            onClick={this.updateClientsBooksForSet}
          />
        </div>
      </div>
    );

    const levelOptions = [
      { label: "Beginner/Progressive", value: "Beginner/Progressive" },
      { label: "Progressive/Intermediate", value: "Progressive/Intermediate" },
      { label: "Intermediate/Advanced", value: "Intermediate/Advanced" },
      { label: "Reformer", value: "Reformer" },
      { label: "Mum and Baby", value: "Mum and Baby" },
      { label: "Antenatal", value: "Antenatal" },
      { label: "Kids", value: "Kids" },
      { label: "Mature Movers", value: "Mature Movers" },
    ];

    const statusOptions = [
      { label: "Coming Soon", value: "Coming Soon" },
      { label: "Active", value: "Active" },
      { label: "Complete", value: "Complete" },
    ];

    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={(el) => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <pr.Growl
          style={{ textAlign: "left" }}
          ref={(el) => (this.growl = el)}
        />
        <div className="ui-g-12">
          <pr.Button
            label="Create Set"
            onClick={() => {
              window.location = "#/createsets";
            }}
            style={{ float: "right" }}
          />
          <pr.Button
            label="Archived Sets"
            onClick={() => {
              window.location = "#/managesetsarchive";
            }}
            style={{ float: "left" }}
          />
        </div>
        <div className="ui-g-12">
          <pr.Dialog
            header="Delete Set"
            footer={
              <div>
                <pr.Button
                  label="Yes"
                  onClick={() => {
                    this.setState({ deleteDialog: false, setSelected: false });
                    this.deleteSet();
                  }}
                  style={{ float: "right" }}
                />
                <pr.Button
                  label="No"
                  onClick={() => {
                    this.setState({ deleteDialog: false });
                  }}
                  style={{ float: "right" }}
                />
              </div>
            }
            visible={this.state.deleteDialog}
            style={{ width: "50vw" }}
            modal={true}
            onHide={(e) => this.setState({ deleteDialog: false })}
          >
            Are you sure you want to delete?
          </pr.Dialog>
          {!this.state.setEdited ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        setEdited: false,
                        setSelected: true,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editSetTitle === ""
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editSetTitle}
                        onChange={(e) =>
                          this.setState({ editSetTitle: e.target.value })
                        }
                      />
                      <label>Title</label>
                    </span>
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                    <label>Level: </label>
                    <pr.Dropdown
                      value={this.state.editSetLevel || ""}
                      options={levelOptions}
                      onChange={(e) => {
                        this.setState({ editSetLevel: e.value });
                      }}
                      style={{ width: "50%" }}
                    />
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "20px" }}>
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editSetMaxNumberOfPartcipants === ""
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editSetMaxNumberOfPartcipants}
                        onChange={(e) =>
                          this.setState({
                            editSetMaxNumberOfPartcipants: e.target.value,
                          })
                        }
                      />
                      <label>Max Number of Participants</label>
                    </span>
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                    <label>Status: </label>
                    <pr.Dropdown
                      value={this.state.editSetStatus || ""}
                      options={statusOptions}
                      onChange={(e) => {
                        this.setState({ editSetStatus: e.value });
                      }}
                    />
                  </div>
                  <div className="ui-g-12" style={{ paddingTop: "10px" }}>
                    <label>Room: </label>
                    <pr.Dropdown
                      value={this.state.editSetRoom || ""}
                      options={this.state.roomOptions}
                      onChange={(e) => {
                        this.setState({ editSetRoom: e.value });
                      }}
                    />
                  </div>
                  <div className="ui-g-12">
                    <label>Client(s): </label>
                    <br />
                    <br />
                    <pr.DataTable
                      value={
                        this.state.selectedSetCompleteBookedListUserDetails
                      }
                      selectionMode="single"
                      onSelectionChange={() => {}}
                      header=" "
                      footer=" "
                      autoLayout={true}
                      paginator={false}
                      alwaysShowPaginator={false}
                      scrollable={true}
                    >
                      <pr.Column
                        field="bookedUserDetails.firstName"
                        header="First Name"
                        body={(e) => {
                          if (
                            e.bookedUserDetails &&
                            e.bookedUserDetails.length
                          ) {
                            return e.bookedUserDetails[0].firstName;
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="bookedUserDetails.surname"
                        header="Surname"
                        body={(e) => {
                          if (
                            e.bookedUserDetails &&
                            e.bookedUserDetails.length
                          ) {
                            return e.bookedUserDetails[0].surname;
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="paid"
                        header="Paid?"
                        body={(e) => {
                          if (e.paid) {
                            return "Yes";
                          } else {
                            return "No";
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="paymentMethod"
                        header="Payment Method"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="multipleSets"
                        header="Multiple Sets"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field=""
                        header=""
                        body={(e) => {
                          return (
                            <pr.Button
                              label="Update"
                              onClick={() => {
                                this.setState({
                                  displayDialog: true,
                                  selectedPaidOnClick: e.paid,
                                  selectedPaymentMethodOnClick: e.paymentMethod,
                                  clientUserId: e.userId,
                                });
                              }}
                              style={{ width: "90%" }}
                            />
                          );
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="Payment Reminder"
                        header="Payment Reminder"
                        body={(e) => {
                          if (e.paid === false || e.paid === undefined) {
                            return (
                              <pr.Button
                                label="Email"
                                onClick={() => {
                                  this.emailUserForPayment(e.userId);
                                }}
                                style={{ width: "90%" }}
                              />
                            );
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field=""
                        header=""
                        body={(e) => {
                          return (
                            <pr.Button
                              label="Delete"
                              onClick={() => {
                                this.deleteClient(e.bookedUserDetails[0].id);
                              }}
                              style={{ width: "90%" }}
                            />
                          );
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                    </pr.DataTable>
                    <pr.Dialog
                      visible={this.state.displayDialog}
                      header="Booked Client Details"
                      modal={true}
                      footer={dialogFooter}
                      onHide={() => this.setState({ displayDialog: false })}
                      style={{ width: "40vw", height: "40vh" }}
                    >
                      <div className="ui-g">
                        <div className="ui-g-12" style={{ padding: ".75em" }}>
                          <label htmlFor="paid">Paid?</label>
                        </div>
                        <div className="ui-g-12" style={{ padding: ".5em" }}>
                          <pr.Dropdown
                            id="paid"
                            value={this.state.selectedPaidOnClick}
                            options={[
                              { label: "Yes", value: true },
                              { label: "No", value: false },
                            ]}
                            onChange={(e) => {
                              this.setState({
                                selectedPaidOnClick: e.value,
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="ui-g-12" style={{ padding: ".75em" }}>
                          <label htmlFor="paymentMethod">Payment Method</label>
                        </div>
                        <div className="ui-g-12" style={{ padding: ".5em" }}>
                          <pr.Dropdown
                            id="paymentMethod"
                            value={this.state.selectedPaymentMethodOnClick}
                            options={[
                              { label: "App", value: "App" },
                              { label: "Cash", value: "Cash" },
                              { label: "Card", value: "Card" },
                              {
                                label: "Bank Transfer",
                                value: "Bank Transfer",
                              },
                              { label: "N/A", value: "N/A" },
                            ]}
                            onChange={(e) => {
                              this.setState({
                                selectedPaymentMethodOnClick: e.value,
                              });
                            }}
                            style={{ width: "100%" }}
                          />
                        </div>
                        <div className="ui-g-12" style={{ padding: ".5em" }}>
                          <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                          </div>
                        </div>
                      </div>
                    </pr.Dialog>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label>Add another client to set</label>
                      <br />
                      <pr.Dropdown
                        value={this.state.selectedClient}
                        options={this.state.clientOptions}
                        onChange={(e) => {
                          this.setState({
                            selectedClient: e.value,
                          });
                        }}
                        filter={true}
                        filterBy="label"
                        filterPlaceholder="Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="ui-g-3">
                      <label>Paid</label>
                      <br />
                      <pr.Dropdown
                        value={this.state.selectedPaid}
                        options={[
                          { label: "Yes", value: true },
                          { label: "No", value: false },
                        ]}
                        onChange={(e) => {
                          this.setState({
                            selectedPaid: e.value,
                          });
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="ui-g-3">
                      <label>Payment Method</label>
                      <br />
                      <pr.Dropdown
                        value={this.state.selectedPaymentMethod}
                        options={[
                          { label: "App", value: "App" },
                          { label: "Cash", value: "Cash" },
                          { label: "Card", value: "Card" },
                          { label: "Bank Transfer", value: "Bank Transfer" },
                          { label: "N/A", value: "N/A" },
                        ]}
                        onChange={(e) => {
                          this.setState({
                            selectedPaymentMethod: e.value,
                          });
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="ui-g-3">
                      <pr.Button
                        label="Add Client"
                        onClick={() => {
                          this.updateClients();
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editSetCost === ""
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editSetCost}
                        onChange={(e) =>
                          this.setState({ editSetCost: e.target.value })
                        }
                      />
                      <label>Price</label>
                    </span>
                  </div>
                  <div className="ui-g-12">
                    <label>Instructor(s): </label>
                    <br />
                    <br />
                    <pr.PickList
                      source={this.state.pickListAvailable || []}
                      target={this.state.pickListSelected || []}
                      sourceHeader="Available"
                      targetHeader="Selected"
                      responsive={true}
                      itemTemplate={(e) => (
                        <span>{e.firstName + " " + e.surname}</span>
                      )}
                      onChange={(e) => {
                        this.setState({
                          pickListAvailable: e.source,
                          pickListSelected: e.target,
                        });
                      }}
                    />
                  </div>
                  {this.state.selectedSetMondayTime ? (
                    <div className="ui-g-12">
                      <b>Monday: </b>
                      <pr.InputText
                        value={this.state.selectedSetMondayStart || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetMondayStart: e.target.value,
                          });
                        }}
                      />
                      <pr.InputText
                        value={this.state.selectedSetMondayEnd || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetMondayEnd: e.target.value,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetTuesdayTime ? (
                    <div className="ui-g-12">
                      <b>Tuesday: </b>
                      <pr.InputText
                        value={this.state.selectedSetTuesdayStart || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetTuesdayStart: e.target.value,
                          });
                        }}
                      />
                      <pr.InputText
                        value={this.state.selectedSetTuesdayEnd || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetTuesdayEnd: e.target.value,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetWednesdayTime ? (
                    <div className="ui-g-12">
                      <b>Wednesday: </b>
                      <pr.InputText
                        value={this.state.selectedSetWednesdayStart || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetWednesdayStart: e.target.value,
                          });
                        }}
                      />
                      <pr.InputText
                        value={this.state.selectedSetWednesdayEnd || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetWednesdayEnd: e.target.value,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetThursdayTime ? (
                    <div className="ui-g-12">
                      <b>Thursday: </b>
                      <pr.InputText
                        value={this.state.selectedSetThursdayStart || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetThursdayStart: e.target.value,
                          });
                        }}
                      />
                      <pr.InputText
                        value={this.state.selectedSetThursdayEnd || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetThursdayEnd: e.target.value,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetFridayTime ? (
                    <div className="ui-g-12">
                      <b>Friday: </b>
                      <pr.InputText
                        value={this.state.selectedSetFridayStart || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetFridayStart: e.target.value,
                          });
                        }}
                      />
                      <pr.InputText
                        value={this.state.selectedSetFridayEnd || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetFridayEnd: e.target.value,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetSaturdayTime ? (
                    <div className="ui-g-12">
                      <b>Saturday: </b>
                      <pr.InputText
                        value={this.state.selectedSetSaturdayStart || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetSaturdayStart: e.target.value,
                          });
                        }}
                      />
                      <pr.InputText
                        value={this.state.selectedSetSaturdayEnd || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetSaturdayEnd: e.target.value,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetSundayTime ? (
                    <div className="ui-g-12">
                      <b>Sunday: </b>
                      <pr.InputText
                        value={this.state.selectedSetSundayStart || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetSundayStart: e.target.value,
                          });
                        }}
                      />
                      <pr.InputText
                        value={this.state.selectedSetSundayEnd || ""}
                        onChange={(e) => {
                          this.setState({
                            selectedSetSundayEnd: e.target.value,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <label />
                  )}
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Save Changes"
                    onClick={() => {
                      this.updateSet();
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Delete Set"
                    onClick={() => {
                      this.setState({ deleteDialog: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="Cancel"
                    onClick={() => {
                      this.setState({
                        setEdited: false,
                        setSelected: true,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          )}

          {!this.state.setSelected ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  <pr.Button
                    className="secondary-btn"
                    icon="pi pi-pencil"
                    onClick={() => {
                      this.setState(
                        {
                          setSelected: false,
                          setEdited: true,
                          editSet: this.state.selectedSet,
                          editSetTitle: this.state.selectedSetTitle,
                          editSetLevel: this.state.selectedSetLevel,
                          editSetMaxNumberOfPartcipants:
                            this.state.selectedSetMaxNumberOfParticipants,
                          editSetStatus: this.state.selectedSetStatus,
                          editSetRoom: this.state.selectedSetRoom,
                          editSetNextClass: this.state.selectedSetNextClass,
                          editSetRoomName: this.state.selectedSetRoomName,
                          editSetCost: this.state.selectedSetCost / 100,
                          editSetInstructors: this.state.selectedSetInstructors,
                          editSetInstructorNames:
                            this.state.selectedSetInstructorNames,
                        },
                        () => {
                          if (Array.isArray(this.state.selectedSetMondayTime)) {
                            this.setState({
                              selectedSetMondayStart:
                                this.state.selectedSetMondayTime[0],
                              selectedSetMondayEnd:
                                this.state.selectedSetMondayTime[1],
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetTuesdayTime)
                          ) {
                            this.setState({
                              selectedSetTuesdayStart:
                                this.state.selectedSetTuesdayTime[0],
                              selectedSetTuesdayEnd:
                                this.state.selectedSetTuesdayTime[1],
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetWednesdayTime)
                          ) {
                            this.setState({
                              selectedSetWednesdayStart:
                                this.state.selectedSetWednesdayTime[0],
                              selectedSetWednesdayEnd:
                                this.state.selectedSetWednesdayTime[1],
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetThursdayTime)
                          ) {
                            this.setState({
                              selectedSetThursdayStart:
                                this.state.selectedSetThursdayTime[0],
                              selectedSetThursdayEnd:
                                this.state.selectedSetThursdayTime[1],
                            });
                          }
                          if (Array.isArray(this.state.selectedSetFridayTime)) {
                            this.setState({
                              selectedSetFridayStart:
                                this.state.selectedSetFridayTime[0],
                              selectedSetFridayEnd:
                                this.state.selectedSetFridayTime[1],
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetSaturdayTime)
                          ) {
                            this.setState({
                              selectedSetSaturdayStart:
                                this.state.selectedSetSaturdayTime[0],
                              selectedSetSaturdayEnd:
                                this.state.selectedSetSaturdayTime[1],
                            });
                          }
                          if (Array.isArray(this.state.selectedSetSundayTime)) {
                            this.setState({
                              selectedSetSundayStart:
                                this.state.selectedSetSundayTime[0],
                              selectedSetSundayEnd:
                                this.state.selectedSetSundayTime[1],
                            });
                          }
                        }
                      );
                    }}
                    style={{ float: "right" }}
                  />
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Title: </b>
                    <label>{this.state.selectedSetTitle || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Level: </b>
                    <b
                      style={
                        this.state.selectedSetLevel === "Beginner/Progressive"
                          ? {
                              background: "#3f51b5",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                          : this.state.selectedSetLevel ===
                            "Progressive/Intermediate"
                          ? {
                              background: "#4caf50",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                          : this.state.selectedSetLevel ===
                            "Intermediate/Advanced"
                          ? {
                              background: "#f44336",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                          : this.state.selectedSetLevel === "Reformer"
                          ? {
                              background: "#e91e63",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                          : this.state.selectedSetLevel === "Mum and Baby"
                          ? {
                              background: "#ffc107",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                          : this.state.selectedSetLevel === "Antenatal"
                          ? {
                              background: "#ff9800",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                          : this.state.selectedSetLevel === "Kids"
                          ? {
                              background: "#00bcd4",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                          : {
                              background: "red",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black",
                            }
                      }
                    >
                      {this.state.selectedSetLevel || "Not Set"}
                    </b>
                  </div>
                  <div className="ui-g-12">
                    <b>Max Number of Participants: </b>
                    <label>
                      {this.state.selectedSetMaxNumberOfParticipants || "0"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Number of Participants: </b>
                    <label>
                      {this.state.selectedSetNumberOfParticipants || "0"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Status: </b>
                    <label>{this.state.selectedSetStatus || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Room: </b>
                    <label>{this.state.selectedSetRoomName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Start Date: </b>
                    <label>
                      {this.state.selectedSetStartDateDisplayString ||
                        "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>End Date: </b>
                    <label>
                      {this.state.selectedSetEndDateDisplayString || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Next Class: </b>
                    <label>
                      {this.state.selectedSetNextClass || "Not Set"}
                    </label>
                  </div>
                  {this.state.selectedSetMondayTime ? (
                    <div className="ui-g-12">
                      <b>Monday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetMondayTime)
                          ? this.state.selectedSetMondayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetTuesdayTime ? (
                    <div className="ui-g-12">
                      <b>Tuesday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetTuesdayTime)
                          ? this.state.selectedSetTuesdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetWednesdayTime ? (
                    <div className="ui-g-12">
                      <b>Wednesday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetWednesdayTime)
                          ? this.state.selectedSetWednesdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetThursdayTime ? (
                    <div className="ui-g-12">
                      <b>Thursday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetThursdayTime)
                          ? this.state.selectedSetThursdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetFridayTime ? (
                    <div className="ui-g-12">
                      <b>Friday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetFridayTime)
                          ? this.state.selectedSetFridayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetSaturdayTime ? (
                    <div className="ui-g-12">
                      <b>Saturday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetSaturdayTime)
                          ? this.state.selectedSetSaturdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetSundayTime ? (
                    <div className="ui-g-12">
                      <b>Sunday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetSundayTime)
                          ? this.state.selectedSetSundayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <b>Price: </b>
                    <label>
                      {"£" + this.state.selectedSetCost / 100 || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Instructor(s): </b>
                    <ul>
                      {this.state.selectedSetInstructorNames.length === 0 ? (
                        <li>Not Set</li>
                      ) : (
                        this.state.selectedSetInstructorNames
                      )}
                    </ul>
                  </div>
                  <div className="ui-g-12">
                    <b>Client(s): </b>
                    <br />
                    <br />
                    <pr.DataTable
                      value={
                        this.state.selectedSetCompleteBookedListUserDetails
                      }
                      selectionMode="single"
                      onSelectionChange={() => {}}
                      header=" "
                      footer=" "
                      autoLayout={true}
                      paginator={false}
                      alwaysShowPaginator={false}
                      scrollable={true}
                    >
                      <pr.Column
                        field="bookedUserDetails.firstName"
                        header="First Name"
                        body={(e) => {
                          if (
                            e.bookedUserDetails &&
                            e.bookedUserDetails.length
                          ) {
                            return e.bookedUserDetails[0].firstName;
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="bookedUserDetails.surname"
                        header="Surname"
                        body={(e) => {
                          if (
                            e.bookedUserDetails &&
                            e.bookedUserDetails.length
                          ) {
                            return e.bookedUserDetails[0].surname;
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="paid"
                        header="Paid?"
                        body={(e) => {
                          if (e.paid) {
                            return "Yes";
                          } else {
                            return "No";
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="paymentMethod"
                        header="Payment Method"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="multipleSets"
                        header="Multiple Sets"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                    </pr.DataTable>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Re-Create Set"
                    onClick={() => {
                      localStorage.setItem("reCreate", true);
                      localStorage.setItem(
                        "reCreateServiceId",
                        this.state.selectedSetServiceId
                      );
                      localStorage.setItem(
                        "reCreateSetId",
                        this.state.selectedSetId
                      );
                      localStorage.setItem(
                        "reCreateMaxParticipants",
                        this.state.selectedSetMaxNumberOfParticipants
                      );
                      localStorage.setItem(
                        "reCreateMondayTime",
                        this.state.selectedSetMondayTime
                      );
                      localStorage.setItem(
                        "reCreateTuesdayTime",
                        this.state.selectedSetTuesdayTime
                      );
                      localStorage.setItem(
                        "reCreateWednesdayTime",
                        this.state.selectedSetWednesdayTime
                      );
                      localStorage.setItem(
                        "reCreateThursdayTime",
                        this.state.selectedSetThursdayTime
                      );
                      localStorage.setItem(
                        "reCreateFridayTime",
                        this.state.selectedSetFridayTime
                      );
                      localStorage.setItem(
                        "reCreateSaturdayTime",
                        this.state.selectedSetSaturdayTime
                      );
                      localStorage.setItem(
                        "reCreateSundayTime",
                        this.state.selectedSetSundayTime
                      );
                      localStorage.setItem(
                        "reCreateRoomId",
                        this.state.selectedSetRoom
                      );
                      localStorage.setItem(
                        "reCreatePickedInstructors",
                        JSON.stringify(this.state.pickListSelected)
                      );
                      window.location = "#/createsets";
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="View Classes"
                    onClick={() => {
                      localStorage.setItem(
                        "selectedSetId",
                        this.state.selectedSetId
                      );
                      localStorage.setItem(
                        "selectedSetServiceId",
                        this.state.selectedSetServiceId
                      );
                      window.location = "#/classessets";
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="ui-g card">
            <div className="ui-g-12">
              <pr.DataTable
                value={this.state.setList}
                selectionMode="single"
                selection={this.state.selectedSet}
                onSelectionChange={(e) => {
                  let instructorNamesArray = [];
                  let i2 = 0;
                  let clientNamesArray = [];
                  let i3 = 0;
                  let roomName = "";

                  if (Array.isArray(this.state.roomList)) {
                    this.state.roomList.forEach((r) => {
                      if (r.id === e.data.roomId) {
                        roomName = r.name;
                      }
                    });
                  }

                  if (Array.isArray(e.data.instructorDetails)) {
                    e.data.instructorDetails.forEach((f) => {
                      instructorNamesArray[i2] = (
                        <li key={i2}>{f.firstName + " " + f.surname}</li>
                      );
                      i2++;
                    });
                  }

                  if (Array.isArray(e.data.bookedUserDetails)) {
                    e.data.bookedUserDetails.forEach((f) => {
                      clientNamesArray[i3] = (
                        <li key={i3}>{f.firstName + " " + f.surname}</li>
                      );
                      i3++;
                    });
                  }

                  if (Array.isArray(e.data.completeBookedListUserDetails)) {
                    e.data.completeBookedListUserDetails.forEach((f) => {
                      f.multipleSets = "No";
                      if (format.isNotNull(this.state.multipleSetUsers)) {
                        this.state.multipleSetUsers.forEach((g) => {
                          if (f.userId === g) {
                            f.multipleSets = "Yes";
                          }
                        });
                      }
                    });
                  }

                  this.setState(
                    {
                      setEdited: false,
                      setSelected: true,
                      selectedSet: e.data,
                      selectedSetId: e.data.id,
                      selectedSetServiceId: e.data.serviceId,
                      selectedSetLastUpdatedDateTime:
                        e.data.lastUpdatedDateTime,
                      selectedSetTitle: e.data.title,
                      selectedSetLevel: e.data.level,
                      selectedSetMaxNumberOfParticipants: e.data.maxSpace,
                      selectedSetNumberOfParticipants:
                        e.data.currentNumberOfUsers,
                      selectedSetStatus: e.data.status,
                      selectedSetRoom: e.data.roomId,
                      selectedSetRoomName: roomName,
                      selectedSetCost: e.data.cost,
                      selectedSetInstructors: e.data.instructorDetails,
                      selectedSetInstructorNames: instructorNamesArray,
                      selectedSetClients: e.data.bookedUserDetails,
                      selectedSetClientNames: clientNamesArray,
                      selectedSetBookList: e.data.bookList,
                      selectedSetCompleteBookedListUserDetails:
                        e.data.completeBookedListUserDetails,
                      pickListSelected: e.data.instructorDetails,
                      selectedSetStartDateDisplayString:
                        e.data.startDateDisplayString,
                      selectedSetEndDateDisplayString:
                        e.data.endDateDisplayString,
                      selectedSetMondayTime: e.data.mondayTime,
                      selectedSetTuesdayTime: e.data.tuesdayTime,
                      selectedSetWednesdayTime: e.data.wednesdayTime,
                      selectedSetThursdayTime: e.data.thursdayTime,
                      selectedSetFridayTime: e.data.fridayTime,
                      selectedSetSaturdayTime: e.data.saturdayTime,
                      selectedSetSundayTime: e.data.sundayTime,
                    },
                    () => {
                      console.log(this.state.selectedSet);
                      this.clientsToOptions();
                      this.getNextClass(this.state.selectedSetId);

                      window.scrollTo({ top: 0, behavior: "smooth" });

                      if (this.state.pickListSelected) {
                        this.removePickListDuplicates();
                      }
                    }
                  );
                }}
                header="Sets"
                footer=" "
                autoLayout={true}
                paginator={false}
                alwaysShowPaginator={false}
                scrollable={true}
              >
                <pr.Column
                  field="title"
                  header="Title"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="level"
                  header="Level"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="instructorDetails"
                  header="Instructors"
                  body={(e) => {
                    let nameArray = [];
                    let i = 0;

                    if (Array.isArray(e.instructorDetails)) {
                      e.instructorDetails.forEach((f) => {
                        nameArray.push(
                          <span key={i}>
                            {(f.firstName || "") + " " + (f.surname || "")}
                            <br />
                          </span>
                        );
                        i++;
                      });
                    }

                    return nameArray;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="dayOfWeek"
                  header="Day of the Week"
                  body={(e) => {
                    let daysToDisplay = [];
                    let i = 0;

                    if (Array.isArray(e.dayOfWeek)) {
                      e.dayOfWeek.forEach((f) => {
                        let num = parseInt(f, 10);
                        if (num === 1) {
                          daysToDisplay.push(
                            <span key={i}>
                              Monday
                              <br />
                            </span>
                          );
                        } else if (num === 2) {
                          daysToDisplay.push(
                            <span key={i}>
                              Tuesday
                              <br />
                            </span>
                          );
                        } else if (num === 3) {
                          daysToDisplay.push(
                            <span key={i}>
                              Wednesday
                              <br />
                            </span>
                          );
                        } else if (num === 4) {
                          daysToDisplay.push(
                            <span key={i}>
                              Thursday
                              <br />
                            </span>
                          );
                        } else if (num === 5) {
                          daysToDisplay.push(
                            <span key={i}>
                              Friday
                              <br />
                            </span>
                          );
                        } else if (num === 6) {
                          daysToDisplay.push(
                            <span key={i}>
                              Saturday
                              <br />
                            </span>
                          );
                        } else if (num === 7) {
                          daysToDisplay.push(
                            <span key={i}>
                              Sunday
                              <br />
                            </span>
                          );
                        } else {
                        }

                        i++;
                      });
                    }

                    return daysToDisplay;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field=""
                  header="Start Time"
                  body={(e) => {
                    let timesToDisplay = [];
                    let i = 0;

                    if (Array.isArray(e.mondayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.mondayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.tuesdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.tuesdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.wednesdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.wednesdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.thursdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.thursdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.fridayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.fridayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.saturdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.saturdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.sundayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.sundayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    return timesToDisplay;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="maxSpace"
                  header="Max Spaces"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="currentNumberOfUsers"
                  header="Number Booked"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="roomId"
                  header="Room"
                  body={(e) => {
                    let roomName = "";

                    if (Array.isArray(this.state.roomList)) {
                      this.state.roomList.forEach((r) => {
                        if (r.id === e.roomId) {
                          roomName = r.name;
                        }
                      });
                    }

                    return roomName;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="status"
                  header="Status"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="costToDisplay"
                  header="Price"
                  body={(e) => {
                    return "£" + e.costToDisplay;
                  }}
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sets/ManageSets.js